$(document).ready(function () {
  $(".ajax-form").on("ajax:success", function(e, data, status, xhr){
    $(this).find('input, textarea').val('');
    $('.js-ajax-form-btn',this).hide();
    $('.ajax-success',this).show();
  }).on("ajax:error", function(e, xhr, status, error){
    $('.js-ajax-form-btn',this).hide();
    $('.ajax-fail',this).show();
  })
});